// extracted by mini-css-extract-plugin
export var tagContainer = "TagList-module--tagContainer--8fe1a";